import { useGetIncomeStatementReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function IncomeStatementReport() {
  const { t } = useTranslation();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:income_statement_report')}
      usePivotQuery={useGetIncomeStatementReports}
      isShowAllFilterCompleted
      defaultFilters={defaultFilters}
    />
  );
}
